<footer class="atw-footer">
  <div class="footer-glow footer-glow-green"></div>
  <div class="footer-glow footer-glow-blue"></div>
  <div class="footer-wave"></div>

  <div class="atw-container footer-container">
    <div class="footer-main">

      <!-- Brand -->
      <div class="footer-brand-col">
        <a routerLink="/Home" class="brand aes-brand">
          <img src="/assets/logo-w.png" [attr.alt]="'header.logoAlt' | transloco" />
        </a>

        <p class="footer-description">
          {{ 'atw.footer.description' | transloco }}
        </p>

        <div class="footer-socials">
          <a
            *ngFor="let social of socialLinks"
            [href]="social.url"
            target="_blank"
            rel="noopener"
            [attr.aria-label]="social.label"
            [title]="social.label"
          >
            <i [class]="social.iconClass" aria-hidden="true"></i>
          </a>
        </div>
      </div>

      <!-- Quick Links -->
      <div class="footer-col">
        <h3>{{ 'atw.footer.quickLinks' | transloco }}</h3>

        <ul>
          <li *ngFor="let link of quickLinks">
            <a [routerLink]="link.route">
              {{ link.labelKey | transloco }}
            </a>
          </li>
        </ul>
      </div>

      <!-- Resources -->
      <div class="footer-col">
        <h3>{{ 'atw.footer.resources' | transloco }}</h3>

        <ul>
          <li *ngFor="let link of resourceLinks">
            <a [routerLink]="link.route">
              {{ link.labelKey | transloco }}
            </a>
          </li>
        </ul>
      </div>

      <!-- Contact -->
      <div class="footer-col footer-contact">
        <h3>{{ 'atw.footer.contactUs' | transloco }}</h3>

        <a [href]="phoneHref" class="footer-contact-item">
          <span>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1C10.61 21 3 13.39 3 4c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.24.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2Z"/>
            </svg>
          </span>
          {{ phoneNumber }}
        </a>

        <div class="footer-contact-item">
          <span>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5Z"/>
            </svg>
          </span>
          {{ 'atw.footer.address' | transloco }}
        </div>
      </div>

      <!-- Newsletter -->
      <div class="footer-col footer-newsletter">
        <h3>{{ 'atw.footer.newsletter' | transloco }}</h3>

        <p>
          {{ 'atw.footer.newsletterText' | transloco }}
        </p>

        <form (submit)="onNewsletterSubmit($event, newsletterEmail)">
          <input
            #newsletterEmail
            type="email"
            [placeholder]="'atw.footer.emailPlaceholder' | transloco"
          />

          <button type="submit" [attr.aria-label]="'atw.footer.subscribe' | transloco">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 2 10.59 3.41 18.17 11H2v2h16.17l-7.58 7.59L12 22l10-10L12 2Z"/>
            </svg>
          </button>
        </form>

        <small *ngIf="newsletterMessageKey" class="footer-newsletter-message">
          {{ newsletterMessageKey | transloco }}
        </small>
      </div>

    </div>

    <div class="footer-bottom">
      <p>
        {{ 'atw.footer.copyright' | transloco:{ year: currentYear } }}
      </p>

      <div class="footer-badges">
        <div class="footer-badge" *ngFor="let badge of badges">
          <span [class]="'footer-badge-icon ' + badge.icon"></span>
          {{ badge.labelKey | transloco }}
        </div>
      </div>
    </div>
  </div>
  <!-- Mobile Fixed Footer -->
<nav class="mobile-fixed-footer" aria-label="Mobile footer navigation">
  <div class="mobile-fixed-footer-inner">
    <a
      *ngFor="let link of mobileFooterLinks"
      [routerLink]="link.route"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ exact: true }"
      class="mobile-fixed-link"
      [attr.aria-label]="link.labelKey | transloco"
    >
      <span class="mobile-fixed-icon">
        <i [class]="link.iconClass" aria-hidden="true"></i>
      </span>

      <strong>
        {{ link.labelKey | transloco }}
      </strong>
    </a>
  </div>
</nav>
</footer>

